module.exports = __webpack_public_path__ + "static/cool-mat-design.454edc03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/wordpress/cool-mat-week-2/images/cool-mat-design.jpg
// module id = 2560
// module chunks = 72803206156579